// Matches Task::GENERAL_QUESTION_UUID in app/models/task.rb
export const GENERAL_TASK_MULTI_ENTRY_QUESTION_UUID = "general-task-question"
